import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// Visual breadcrumb. Pair with breadcrumbSchema() to emit the matching JSON-LD.
// items: [{ name, path }]  — last item should be the current page (rendered as text).
export default function Breadcrumb({ items = [], theme = "dark" }) {
  if (!items.length) return null;
  const isDark = theme === "dark";
  const muted = isDark ? "text-white/50" : "text-slate-500";
  const hover = isDark ? "hover:text-white" : "hover:text-slate-900";
  const current = isDark ? "text-white" : "text-slate-900";

  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumb" className={`flex items-center flex-wrap gap-1.5 text-xs ${muted}`}>
      {items.map((item, i) => {
        const last = i === items.length - 1;
        return (
          <React.Fragment key={item.path}>
            {last ? (
              <span className={`font-medium ${current}`} aria-current="page">{item.name}</span>
            ) : (
              <Link to={item.path} className={`${hover} transition-colors`}>{item.name}</Link>
            )}
            {!last && <ChevronRight className="w-3 h-3 opacity-60" />}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
